import { pathOr } from 'ramda';

import { ICoordinates } from '../../types/geo';
import { IApplicationState } from '../../types/redux';

export function getGeoCoordinates(state: IApplicationState): ICoordinates | null {
  return pathOr(null, ['newbuilding', 'geo', 'coordinates'], state);
}
